import { SET_USER_COMMENTS } from "../constants/actionTypes";

export const setUserComments = comments => {
  return {
    type: SET_USER_COMMENTS,
    payload: comments
  };
};



// WEBPACK FOOTER //
// ./src/actions/userCommentsActions.js